<template>
    <div class="dashboard-welcome">
        <div class="welcome-title">欢迎使用 TAX AGENT</div>
    </div>
</template>

<script>
export default {
    name: 'HomePage',
};
</script>

<style scoped>
.dashboard-welcome {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 64px);
    background: #ffffff;
}

.welcome-title {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}
</style>
